import { useState } from 'react';
import type { AhPayload } from '../ahReport';
import { AreaChart } from '../charts';
import { fmtNum, fmtTimeNL, elapsedDayCount } from '../utils';

export function EngagementSection({ data, days }: { data: AhPayload; days: Date[] }) {
  const t = data.totals;
  const [series, setSeries] = useState<'gameplays' | 'uniqueVisitors' | 'missions'>('gameplays');
  const seriesMap = {
    gameplays: { label: 'Spellen', data: data.gameplays, color: '#0E4A82', total: t.gameplays },
    uniqueVisitors: { label: 'Unieke bezoekers', data: data.uniqueVisitors, color: '#1B6FB8', total: t.uniqueVisitors },
    missions: { label: 'Digital missions', data: data.missions, color: '#B89030', total: t.missions },
  } as const;
  const cur = seriesMap[series];
  const elapsed = elapsedDayCount(days);
  const chartDays = days.slice(0, elapsed);
  const chartData = cur.data.slice(0, elapsed);
  const dailyAvg = chartData.length ? Math.round(chartData.reduce((a, b) => a + b, 0) / chartData.length) : 0;

  return (
    <section id="engagement" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">02 — Engagement</div>
          <h2>Dagelijks ritme</h2>
        </div>
        <div className="description">Vier weken, twee periodes. De silver-rotatie op 22 juni gaf een merkbare boost in week 3.</div>
      </div>

      <div className="card">
        <div className="card-head">
          <h3>{cur.label} per dag</h3>
          <div style={{ display: 'flex', gap: 4 }}>
            {Object.entries(seriesMap).map(([k, v]) => (
              <button key={k} className={'preset-chip' + (series === k ? ' active' : '')} onClick={() => setSeries(k as keyof typeof seriesMap)}>
                {v.label}
              </button>
            ))}
          </div>
        </div>
        <div className="trend-block">
          <div className="trend-summary">
            <div className="label">Totaal — campagne</div>
            <div className="big">{fmtNum(cur.total)}</div>
            <div className="desc">Gemiddeld {fmtNum(dailyAvg)} per dag.</div>
          </div>
          <AreaChart data={chartData} days={chartDays} color={cur.color} label={cur.label} height={220} />
        </div>
      </div>

      <div className="card" style={{ marginTop: 16 }}>
        <div className={`big-stat-row${t.avgSessionDuration ? '' : ' big-stat-row-2'}`}>
          <div className="big-stat">
            <div className="label">Spellen / gebruiker</div>
            <div className="value">{t.avgGamesPerUser}</div>
            <div className="desc">Gemiddeld over alle deelnemers</div>
          </div>
          <div className="big-stat">
            <div className="label">Tijd / gebruiker</div>
            <div className="value">{fmtTimeNL(t.avgPresentationPerUser)}</div>
            <div className="desc">{fmtTimeNL(t.presentationTime)} totaal in app</div>
          </div>
          {t.avgSessionDuration && (
            <div className="big-stat">
              <div className="label">Tijd / sessie</div>
              <div className="value">{fmtTimeNL(t.avgSessionDuration)}</div>
              <div className="desc">gem. sessieduur over {fmtNum(t.uniqueVisits)} sessies</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
